import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import { ImageLogoAtomSimpleYellow } from '~/assets/images';
import { useAuth } from '~/hooks/auth';

import { Container, Wrapper, Title } from './styles';

const Unauthorized = () => {
  const { user } = useAuth();
  const { push } = useHistory();

  const options: { [key: string]: string } = {
    student: '/student/students',
    professional: '/professional/students',
    gym: '/gym/students',
  };

  const [isUserAuthenticated, setIsUserAuthenticated] = useState(!!user);

  useEffect(() => {
    setTimeout(() => {
      if (user) {
        push(options[user.role]);
      } else {
        push('/');
      }
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsUserAuthenticated(!!user);
  }, [user]);

  return (
    <Container>
      <Wrapper>
        <ImageLogoAtomSimpleYellow />

        <Title>
          {isUserAuthenticated
            ? 'Login efetuado com sucesso, redirecionando...'
            : 'Acesso não autorizado , em breve você será redirecionado(a).'}
        </Title>
      </Wrapper>
    </Container>
  );
};

export default Unauthorized;
